import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconFavoritesComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} strokeWidth={1.5}>
      <path
        d="M21 8.25a4.6 4.6 0 0 0-4.69-4.5A4.7 4.7 0 0 0 12 6.48a4.7 4.7 0 0 0-4.31-2.73A4.6 4.6 0 0 0 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
        fill="none"
        stroke="currentColor"
      />
    </SvgIcon>
  );
};
IconFavoritesComponent.displayName = 'IconFavorites';

const IconFavorites = memo(IconFavoritesComponent);

export default IconFavorites;
